import { Box, Text, VStack, HStack } from '@chakra-ui/react';
import type { ItineraryTurfPoolDto } from '../../../types/campaign'
import { ItineraryTurfPoolCard } from './ItineraryTurfPoolCard'

interface ItineraryTurfPoolProps {
  turfs: ItineraryTurfPoolDto[]
}

export function ItineraryTurfPool({ turfs }: ItineraryTurfPoolProps) {
  return (
    <Box
      w="220px"
      flexShrink={0}
      bg="surface"
      borderRadius="lg"
      border="1px solid"
      borderColor="gray.200"
      p={3}
      overflowY="auto"
      maxH="calc(100vh - 300px)"
    >
      <Text fontWeight="semibold" fontSize="sm" mb={2}>
        Turf Pool
      </Text>

      <VStack gap={0} align="stretch">
        {turfs.length === 0 && (
          <Text fontSize="xs" color="gray.400" textAlign="center" py={4}>
            No turfs available
          </Text>
        )}
        {turfs.map(turf => (
          <ItineraryTurfPoolCard key={turf.turfId} turf={turf} />
        ))}
      </VStack>

      <HStack mt={3} pt={2} borderTop="1px solid" borderColor="gray.100" justify="space-between">
        <Text fontSize="2xs" color="gray.500">
          {turfs.length} turf{turfs.length !== 1 ? 's' : ''}
        </Text>
      </HStack>
    </Box>
  );
}
